import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import RestartAltRounded from "@mui/icons-material/RestartAltRounded";
import noResults from "../../../../../../public/images/noSearchResults.svg";
import { Filetype } from "../../../../../shell/store/media-revamp";
import { useParams } from "../../../../../shell/hooks/useParams";
type Props = {
  filetype: Filetype;
};
export const NoResultsState: FC<Props> = ({
  filetype
}) => {
  const {
    t
  } = useTranslation();
  const [params, setParams] = useParams();
  return <Box component="main" sx={{
    flex: 1,
    display: "flex",
    flexDirection: "column",
    height: "100%"
  }} data-sentry-element="Box" data-sentry-component="NoResultsState" data-sentry-source-file="NoResultsState.tsx">
      <Box display="flex" justifyContent="center" alignItems="center" height="100%" textAlign={"center"} className="NoResultsState" data-sentry-element="Box" data-sentry-source-file="NoResultsState.tsx">
        <Box width="400px" data-sentry-element="Box" data-sentry-source-file="NoResultsState.tsx">
          <img src={noResults} height="320px" />
          <Typography sx={{
          mt: 8
        }} variant="h4" fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="NoResultsState.tsx">
            {filetype === "Folder" ? t("media.noResultsStateTitleFolders") : t("media.noResultsStateTitleFiletype", {
            filetype
          })}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{
          mb: 2
        }} data-sentry-element="Typography" data-sentry-source-file="NoResultsState.tsx">
            {t("media.noResultsStateDescription")}
          </Typography>
          <Button variant="contained" onClick={() => {
          setParams(null, "to");
          setParams(null, "from");
          setParams(null, "filetype");
          setParams(null, "sort");
          setParams(null, "dateFilter");
        }} color="primary" size="small" startIcon={<RestartAltRounded />} data-sentry-element="Button" data-sentry-source-file="NoResultsState.tsx">
            {t("media.noResultsStateClearFilters")}
          </Button>
        </Box>
      </Box>
    </Box>;
};